import React, { useMemo, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

function RegisterUser() {
    const navigate = useNavigate();
    const location = useLocation();
    const { register } = useAuth();

    const [formData, setFormData] = useState({
        userName: '',
        email: location.state?.email || '',
        phone: '',
        password: '',
        confirmPassword: '',
        agreeTerms: false,
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const [errorCode, setErrorCode] = useState('');

    const redirectMessage = useMemo(() => location.state?.message || '', [location.state]);

    const handleChange = (event) => {
        const { name, type, checked, value } = event.target;
        setFormData((previous) => ({
            ...previous,
            [name]: type === 'checkbox' ? checked : value,
        }));
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setErrorMessage('');
        setErrorCode('');

        if (formData.password !== formData.confirmPassword) {
            setErrorMessage('Password and confirm password do not match.');
            return;
        }

        if (!formData.agreeTerms) {
            setErrorMessage('Please agree to terms and policy.');
            return;
        }

        setIsSubmitting(true);

        const result = await register({
            userName: formData.userName,
            email: formData.email,
            phone: formData.phone,
            password: formData.password,
        });

        setIsSubmitting(false);

        if (result.success) {
            navigate('/verify-otp', {
                replace: true,
                state: {
                    email: formData.email,
                    message: result?.data?.message || 'OTP sent to your email. Please verify to continue.',
                    otpSent: true,
                },
            });
            return;
        }

        setErrorCode(result.code || 'REGISTER_FAILED');
        setErrorMessage(result.message || 'Unable to register user.');
    };

    const registrationErrorAlert = () => {
        if (!errorMessage) {
            return null;
        }

        const loginLink = <Link to="/login">Login</Link>;
        const codesWithLogin = ['EMAIL_AND_PHONE_EXISTS', 'EMAIL_EXISTS', 'PHONE_EXISTS', 'EMAIL_EXISTS_PHONE_MISMATCH'];

        if (codesWithLogin.includes(errorCode)) {
            return (
                <div className="alert alert-danger py-2">
                    {errorMessage} {loginLink}
                </div>
            );
        }

        return <div className="alert alert-danger py-2">{errorMessage}</div>;
    };

  return (
    <div className="page-content pt-20 pb-20">
            <div className="container">
                <div className="row">
                    <div className="col-xl-8 col-lg-10 col-md-12 m-auto">
                        <div className="row">
                            <div className="col-lg-6 col-md-8">
                                <div className="login_wrap widget-taber-content background-white">
                                    <div className="padding_eight_all bg-white">
                                        <div className="heading_s1">
                                            <h1 className="mb-5">Create an Account</h1>
                                            <p className="mb-30">Already have an account? <Link to="/login">Login</Link></p>
                                        </div>
                                        {redirectMessage ? <div className="alert alert-info py-2">{redirectMessage}</div> : null}
                                        {registrationErrorAlert()}
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group">
                                                <input type="text" required name="userName" value={formData.userName} onChange={handleChange} placeholder="Username" />
                                            </div>
                                            <div className="form-group">
                                                <input type="email" required name="email" value={formData.email} onChange={handleChange} placeholder="Email" />
                                            </div>
                                            <div className="form-group">
                                                <input type="tel" required name="phone" value={formData.phone} onChange={handleChange} placeholder="Phone Number *" />
                                            </div>
                                            <div className="form-group">
                                                <input required type="password" name="password" value={formData.password} onChange={handleChange} placeholder="Password" />
                                            </div>
                                            <div className="form-group">
                                                <input required type="password" name="confirmPassword" value={formData.confirmPassword} onChange={handleChange} placeholder="Confirm password" />
                                            </div>
                                            <div className="login_footer form-group mb-50">
                                                <div className="chek-form">
                                                    <div className="custome-checkbox">
                                                        <input className="form-check-input" type="checkbox" name="agreeTerms" id="exampleCheckbox12" checked={formData.agreeTerms} onChange={handleChange} />
                                                        <label className="form-check-label" htmlFor="exampleCheckbox12"><span>I
                                                                agree to terms &amp; Policy.</span></label>
                                                    </div>
                                                </div>
                                                <a href="page-privacy-policy"><i
                                                        className="fi-rs-book-alt mr-5 text-muted"></i>Lean more</a>
                                            </div>
                                            <div className="form-group mb-30">
                                                <button type="submit"
                                                    className="btn btn-fill-out btn-block hover-up font-weight-bold"
                                                    name="login" disabled={isSubmitting}>{isSubmitting ? 'Registering...' : 'Submit & Register'}</button>
                                            </div>
                                            <p className="font-xs text-muted"><strong>Note:</strong>Your personal data will
                                                be used to support your experience throughout this website, to manage
                                                access to your account, and for other purposes described in our privacy
                                                policy</p>
                                        </form>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-6 pr-30 d-none d-lg-block">
                                <div className="card-login mt-115">
                                    <a href="/register" className="social-login facebook-login">
                                        <img src="assets/imgs/theme/icons/logo-facebook.svg" alt="Facebook"/>
                                        <span>Continue with Facebook</span>
                                    </a>
                                    <a href="/register" className="social-login google-login">
                                        <img src="assets/imgs/theme/icons/logo-google.svg" alt="Google"/>
                                        <span>Continue with Google</span>
                                    </a>
                                    <a href="/register" className="social-login apple-login">
                                        <img src="assets/imgs/theme/icons/logo-apple.svg" alt="Apple"/>
                                        <span>Continue with Apple</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  )
}

export default RegisterUser;